const guest = [];
const admin = ["ADMIN"];

export default {
  guest,
  admin,
};
